import { createContext, useContext, useEffect, useState } from "react";
import axiosInstance from "../api/axiosInstance";
import { set } from "date-fns";

const DjContext = createContext();

export const useDjContext = () => useContext(DjContext);

export const DjProvider = ({ djId, token, children }) => {
  const [isOnline, setIsOnline] = useState(false);
  const [place, setPlace] = useState(null);
  const [price, setPrice] = useState(null);
  const [qrCodeImg, setQrCodeImg] = useState(null);

  const fetchInfo = async () => {
    try {
      const { data } = await axiosInstance.get(`/dj/${djId}/info`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      setIsOnline(data.online);
      setPlace(data.placeName);
      setPrice(data.currentPrice);
      setQrCodeImg(data.qrCodeUrl);
    } catch (err) {
      console.error("Failed to fecth DJ info", err);
    }
  };

  useEffect(() => {
    fetchInfo();
  }, [djId]);

  const handleGoOffline = async () => {
    try {
      await axiosInstance.patch(
        `/dj/${djId}/status-update`,
        { online: false },
        { headers: { Authorization: `Bearer ${token}` } },
      );

      setIsOnline((prev) => !prev);
      setPlace(null);
      setPrice(null);
      setQrCodeImg(null);
    } catch (err) {
      console.error("Error going offline", err);
    }
  };

  return (
    <DjContext.Provider
      value={{
        djId,
        token,
        isOnline,
        place,
        price,
        qrCodeImg,
        handleGoOffline,
        fetchInfo,
      }}
    >
      {children}
    </DjContext.Provider>
  );
};
